var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOffer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-offer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bag-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.146,8.347a5.545,5.545,0,0,0-3.693-1.583V5.853A5.863,5.863,0,0,0,10.027.027,6.171,6.171,0,0,0,4.752,6.069v.7A5.545,5.545,0,0,0,1.059,8.347a5.272,5.272,0,0,0-1,4.22L.9,19.245c.252,2.338,1.2,4.736,6.354,4.736h6.69c5.155,0,6.1-2.4,6.354-4.724l.839-6.7A5.3,5.3,0,0,0,20.146,8.347ZM10.195,1.693a4.178,4.178,0,0,1,4.592,4.16v.839H6.418V6.069A4.509,4.509,0,0,1,10.195,1.693ZM6.31,13.37H6.3a1.2,1.2,0,1,1,.012,0Zm8.392,0h-.012a1.2,1.2,0,1,1,.012,0Z",
    transform: "translate(3.398 1.686)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    transform: "translate(28 28) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOffer);
export default __webpack_public_path__ + "static/media/icon-offer.59efe1a9cd79002c364cd3ef05ca2e12.svg";
export { ForwardRef as ReactComponent };